import * as React from 'react';
import ouiDom from '@goldwasserexchange/oui-dom';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useHookstate } from '@hookstate/core';
import { Loader } from 'react-feather';
import { newsLetterSubmittingState } from '../../../../../../state';

export const NewsLetterBoxFormSubmitButtonContainer = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  const submitting = useHookstate(newsLetterSubmittingState);
  return (
    <ouiDom.Button.Button
      type="submit"
      color={ouiStyle.Constants.Colors.inverted}
      borderColor={ouiStyle.Constants.Colors.logoBlue}
      backgroundColor={ouiStyle.Constants.Colors.logoBlue}
      hoverBackgroundColor={ouiStyle.Constants.Colors.primaryShaded}
      borderLeftRadius="full"
      borderRightRadius="full"
      paddingVertical="half"
      disabled={submitting.get()}
    >
      {submitting.get() === false
        ? children
        : <Loader color={ouiStyle.Constants.Colors.inverted} size="1rem" />}
    </ouiDom.Button.Button>
  );
};
